import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
    Select,
    SelectTrigger,
    SelectValue,
    SelectContent,
    SelectItem
} from 'src/@/components/ui/select';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { Input } from 'src/@/components/ui/input';
import { Switch } from 'src/@/components/ui/switch';

export default function HorarioAtendimentoAutomacao({
    diasSemana,
    dataAgente,
    customSchedule,
    scheduleService,
    changeCustomScheduleService,
    changeScheduleService
}) {
    const { t } = useTranslation('automation');

    console.log('scheduleService', scheduleService);

    return (
        <div className="p-2">
            <h2 className="text-sm font-bold mb-4">{t('schedule.customLabel', 'Horário customizado')}</h2>
            <div className="flex items-center space-x-4 mb-6">

                <Switch
                    checked={customSchedule}
                    onCheckedChange={changeCustomScheduleService}
                />
                <label htmlFor="dias-customizados" className="text-sm">
                    {t('schedule.customLabel', 'Horário customizado')}
                </label>
            </div>

            {
                customSchedule &&
                <div className="space-y-2 p-2 rounded-lg">
                    {scheduleService.map((horario, index) => (
                        <div key={index} className="flex">
                            <div className="flex items-center gap-2">
                                <Checkbox
                                    checked={horario.ativo}
                                    onCheckedChange={(ativo) => changeScheduleService(index, "ativo", ativo)}
                                />
                                <span className="w-24 text-xs">{`${horario.dia}`}</span>
                            </div>

                            <div className="flex flex-row gap-1 items-center w-full">
                                <Input
                                    type="time"
                                    value={horario.inicio}
                                    onChange={(e) => changeScheduleService(index, "inicio", e.target.value)}
                                    className="w-20 h-8"
                                />
                                <span className='p-1 text-xs'>{t('schedule.until', 'até')}</span>
                                <Input
                                    type="time"
                                    value={horario.fim}
                                    onChange={(e) => changeScheduleService(index, "fim", e.target.value)}
                                    className="w-20 h-8"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            }



        </div>
    );
}
